export const classNames = {
    main: "ps",
    rtl: "ps__rtl",
    element: {
        thumb: (bl, x) => `${bl}__scroll-thumb-${x}`,
        rail: (bl, x) => `${bl}__scroll-rail-${x}`,
        consuming: "ps__child--consume",
    },
    state: {
        focus: bl => `${bl}__focus`,
        clicking: "ps--clicking",
        active: (bl, x) => `${bl}_active-${x}`,
        scrolling: (bl, x) => `${bl}_scrolling-${x}`,
    },
};
